module.exports = __webpack_public_path__ + "img/chognzhi.a7776a3c.svg";